#!/usr/bin/env node

import { execSync, spawn } from 'child_process'

const MAIN_BRANCH = 'dev'

const currentBranch = execSync('git branch --show-current').toString().trim()
if (currentBranch !== MAIN_BRANCH) {
  console.error(
    `Must be on ${MAIN_BRANCH} to publish. Merge your changes to dev through the PR process before publishing`,
  )
  process.exit(1)
}

// eslint-disable-next-line @typescript-eslint/no-var-requires
const versionNumber = require('./package.json').version

const publish = spawn('npm', ['publish', '--access', 'public'], {
  cwd: '../bazel-bin/custom_component_support/support_npm_package',
  stdio: ['inherit', 'inherit', 'inherit'],
})

publish.addListener('close', (code) => {
  if (code === 0) {
    const commitHash = execSync('git log -n 1 dev --pretty=format:"%H"').toString().trim().substring(0, 8)
    const tagName = `custom-component-support-${versionNumber}-${commitHash}`
    execSync(`git tag ${tagName}`)
    execSync(`git push origin ${tagName}`)
    process.exit(0)
  } else {
    console.log('Failed to publish, not pushing tags')
    process.exit(1)
  }
})
